// extracted by mini-css-extract-plugin
export var cardLayout = "_7x-1";
export var paginationContainer = "_7x-0";